module.exports = __webpack_public_path__ + "img/detail-website.6237b281.svg";